import { SearchResult } from './SearchResult';

/** Represents the results that come back from a global search. */
export class SearchCollection {
	public decks: SearchResult[];
	public companies: SearchResult[];
	public artists: SearchResult[];
	public pros: SearchResult[];
}
